var _filter, _filter2, _filter3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualLookupImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 262,
    viewBox: "0 0 390 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33946_89778)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 262,
    rx: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33946_89778)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_33946_89778)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 53,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.9997,
    cy: 70.9999,
    rx: 6.66667,
    ry: 6.66667,
    fill: "url(#paint0_linear_33946_89778)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.3337 90.1667C68.3337 94.3089 68.3337 97.6667 55.0003 97.6667C41.667 97.6667 41.667 94.3089 41.667 90.1667C41.667 86.0246 47.6365 82.6667 55.0003 82.6667C62.3641 82.6667 68.3337 86.0246 68.3337 90.1667Z",
    fill: "url(#paint1_linear_33946_89778)",
    style: {}
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 53,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_33946_89778)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_33946_89778)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 53,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#FCD19C",
    style: {
      fill: "#FCD19C",
      fill: "color(display-p3 0.9882 0.8196 0.6118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202,
    cy: 70.9999,
    rx: 6.66667,
    ry: 6.66667,
    fill: "url(#paint2_linear_33946_89778)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M215.334 90.1667C215.334 94.3089 215.334 97.6667 202 97.6667C188.667 97.6667 188.667 94.3089 188.667 90.1667C188.667 86.0246 194.637 82.6667 202 82.6667C209.364 82.6667 215.334 86.0246 215.334 90.1667Z",
    fill: "url(#paint3_linear_33946_89778)",
    style: {}
  })), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 53,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_33946_89778)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 53,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#6FCBD4",
    style: {
      fill: "#6FCBD4",
      fill: "color(display-p3 0.4353 0.7961 0.8314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 53,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 62C333.49 62 329 66.49 329 72C329 77.51 333.49 82 339 82C344.51 82 349 77.51 349 72C349 66.49 344.51 62 339 62ZM343.78 69.7L338.11 75.37C337.97 75.51 337.78 75.59 337.58 75.59C337.38 75.59 337.19 75.51 337.05 75.37L334.22 72.54C333.93 72.25 333.93 71.77 334.22 71.48C334.51 71.19 334.99 71.19 335.28 71.48L337.58 73.78L342.72 68.64C343.01 68.35 343.49 68.35 343.78 68.64C344.07 68.93 344.07 69.4 343.78 69.7Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81 72L176 72",
    stroke: "#E8E8E8",
    style: {
      stroke: "#E8E8E8",
      stroke: "color(display-p3 0.9083 0.9083 0.9083)",
      strokeOpacity: 1
    },
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 72L313 72",
    stroke: "#E8E8E8",
    style: {
      stroke: "#E8E8E8",
      stroke: "color(display-p3 0.9083 0.9083 0.9083)",
      strokeOpacity: 1
    },
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 94.75H366.25V319.25H20.75V118C20.75 105.159 31.1594 94.75 44 94.75Z",
    stroke: "#EFF1F3",
    style: {
      stroke: "#EFF1F3",
      stroke: "color(display-p3 0.9373 0.9451 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 153.75,
    x2: 43.6348,
    y2: 153.75,
    stroke: "#EFF1F3",
    style: {
      stroke: "#EFF1F3",
      stroke: "color(display-p3 0.9373 0.9451 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 257.75,
    x2: 43.6348,
    y2: 257.75,
    stroke: "#EFF1F3",
    style: {
      stroke: "#EFF1F3",
      stroke: "color(display-p3 0.9373 0.9451 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362,
    y1: 205.75,
    x2: 45.6348,
    y2: 205.75,
    stroke: "#EFF1F3",
    style: {
      stroke: "#EFF1F3",
      stroke: "color(display-p3 0.9373 0.9451 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6348,
    y: 117,
    width: 32,
    height: 20,
    rx: 10,
    fill: "#EBECEF",
    style: {
      fill: "#EBECEF",
      fill: "color(display-p3 0.9216 0.9255 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6348,
    y: 117,
    width: 112,
    height: 20,
    rx: 10,
    fill: "#F2F4F7",
    style: {
      fill: "#F2F4F7",
      fill: "color(display-p3 0.9490 0.9569 0.9686)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6348,
    y: 169,
    width: 32,
    height: 20,
    rx: 10,
    fill: "#EBECEF",
    style: {
      fill: "#EBECEF",
      fill: "color(display-p3 0.9216 0.9255 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6348,
    y: 169,
    width: 82,
    height: 20,
    rx: 10,
    fill: "#F2F4F7",
    style: {
      fill: "#F2F4F7",
      fill: "color(display-p3 0.9490 0.9569 0.9686)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6348,
    y: 221,
    width: 32,
    height: 20,
    rx: 10,
    fill: "#EBECEF",
    style: {
      fill: "#EBECEF",
      fill: "color(display-p3 0.9216 0.9255 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6348,
    y: 221,
    width: 169,
    height: 20,
    rx: 10,
    fill: "#F2F4F7",
    style: {
      fill: "#F2F4F7",
      fill: "color(display-p3 0.9490 0.9569 0.9686)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33946_89778",
    x: 20,
    y: 38.5,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33946_89778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33946_89778",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_33946_89778",
    x: 167,
    y: 38.5,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33946_89778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33946_89778",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_33946_89778",
    x: 304,
    y: 38.5,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33946_89778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33946_89778",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33946_89778",
    x1: 53.41,
    y1: 74.9972,
    x2: 67.4949,
    y2: 56.2173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33946_89778",
    x1: 55.0003,
    y1: 82.6667,
    x2: 55.0004,
    y2: 94.6574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33946_89778",
    x1: 200.41,
    y1: 74.9972,
    x2: 214.495,
    y2: 56.2173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33946_89778",
    x1: 202,
    y1: 82.6667,
    x2: 202,
    y2: 94.6574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33946_89778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 262,
    rx: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_33946_89778"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 53,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_33946_89778"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 53,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualLookupImg);
export default __webpack_public_path__ + "static/media/individual-lookup-img.82abf8f181ca6651c415df3c998403dd.svg";
export { ForwardRef as ReactComponent };